/**
 * Created by olga on 03.07.2026
 */

const ChooseLineWindow = Prefab.createWindow(
    "choose_line_window",
    "chooseline_window_prefab_json"
);